// VITE_APP_ENVIRONMENT is set in set_dev_env.sh and set_prod_env.sh to
// development and production respectively

// if you want to use the local or test environments, you'll need to set those
// explicitly when you run the app

//my.securityjourney.dev
const DEVELOPMENT = "development";

//my.securityjourney.com
const PRODUCTION = "production";

//localhost
const LOCAL = "local";

//cypress || test-pa11y locally
const TEST = "test";

const DEPLOYMENT_MODES = [DEVELOPMENT, PRODUCTION];
const DEVELOPMENT_MODES = [DEVELOPMENT, LOCAL];
const TEST_MODES = [TEST];
const PRODUCTION_MODES = [PRODUCTION];
const LOCAL_MODES = [LOCAL];
const DEPLOYED_DEV_MODES = [DEVELOPMENT];

export const IS_ATLAS_BUILD = import.meta.env.VITE_ATLAS_BUILD === "1";
export const IS_DEPLOYMENT_MODE = DEPLOYMENT_MODES.includes(import.meta.env.VITE_APP_ENVIRONMENT);
export const IS_DEV_MODE = DEVELOPMENT_MODES.includes(import.meta.env.VITE_APP_ENVIRONMENT);
export const IS_TEST_MODE = TEST_MODES.includes(import.meta.env.VITE_APP_ENVIRONMENT);
export const IS_PRODUCTION_MODE = PRODUCTION_MODES.includes(import.meta.env.VITE_APP_ENVIRONMENT);
export const IS_LOCAL_MODE = LOCAL_MODES.includes(import.meta.env.VITE_APP_ENVIRONMENT);
export const IS_DEPLOYED_DEV_MODE = DEPLOYED_DEV_MODES.includes(
  import.meta.env.VITE_APP_ENVIRONMENT
);
